import { useMutation, useQuery } from "react-query";
import { ChargeSessionService } from "./charge-session.service";
import toast from "react-hot-toast";

// GET List
const useGetList = (page: number, query?: object) => {
  return useQuery(
    ["listSession", page, query],
    async () => {
      const { data } = await ChargeSessionService.getListChargeSession({
        page,
        ...query,
      });
      return data;
    },
    { keepPreviousData: true },
  );
};

// GET Detail
const useGetDetail = (id: string) => {
  return useQuery(["getDetail", id], async () => {
    const { data } = await ChargeSessionService.getDetailChargeSession(id);
    return data;
  });
};

const useGetSettleEnergy = (id: string) => {
  return useQuery(["getSettleEnergy", id], async () => {
    if (id) {
      const { data } =
        await ChargeSessionService.getSettleEnergyChargeSession(id);
      return data;
    }

    return [];
  });
};

// const useSettleEnergyApply = (id: string) => {
//   return useQuery(["getSettleEnergy", id], async () => {
//     const { data } = await ChargeSessionService.applySettleEnergyChargeSession(id);
//     return data;
//   });
// };

const useSettleEnergyApply = (cb?: (data: any) => void) => {
  return useMutation(
    async (payload: any) => {
      const data =
        await ChargeSessionService.applySettleEnergyChargeSession(payload);
      return data;
    },
    {
      onSuccess: (data) => {
        cb?.(data);
        if (data.ok) {
          toast.success("Invalidate successfully!");
        } else {
          toast.error(data?.msg);
        }
      },
      onError(error, variables, context) {
        alert(error);
      },
    },
  );
};

const useFlushSession = (cb?: (data: any) => void) => {
  return useMutation(
    async (payload: any) => {
      const data =
        await ChargeSessionService.flushSession(payload);
      return data;
    }
  );
};

export { useGetList, useGetDetail, useGetSettleEnergy, useSettleEnergyApply, useFlushSession };
